var _path, _path2, _path3, _path4, _path5, _path6, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoMobile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 40,
    viewBox: "0 0 36 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.3234 9.98592V29.9569L31.0518 32.4232V12.3528L27.6422 10.3843V34.3917L23.4526 36.8108V7.96522L20.0431 5.99751V38.7785L18.0282 39.942L15.8542 38.6874V1.25466L18.0282 0L20.0431 1.16356L23.4526 3.13126L27.6422 5.55031L31.0518 7.51884L35.3234 9.98592Z",
    fill: "#647CFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33125 5.59836L4.92173 7.56606L0.73291 9.98428V29.957L4.92173 32.3752L8.33125 34.3437L12.4447 36.7189V3.22321L8.33125 5.59836ZM8.33125 29.6191L4.92173 27.6505V12.405L8.33125 10.4365V29.6191Z",
    fill: "#647CFD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33124 10.4364L12.4447 8.06128V18.3851L8.33124 18.5946V10.4364Z",
    fill: "url(#paint0_linear_310_116)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8542 3.57932L20.0431 5.99753V14.7271H15.8542V3.57932Z",
    fill: "url(#paint1_linear_310_116)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4534 7.96689L27.6422 10.3851V19.1155H23.4534V7.96689Z",
    fill: "url(#paint2_linear_310_116)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0509 12.3528L35.3234 14.819V23.5006H31.0509V12.3528Z",
    fill: "url(#paint3_linear_310_116)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_310_116",
    x1: 10.3876,
    y1: 16.6087,
    x2: 10.3876,
    y2: 5.93457,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#647CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#38468F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_310_116",
    x1: 17.9487,
    y1: 13.7979,
    x2: 17.9487,
    y2: 2.80002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#647CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#38468F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_310_116",
    x1: 25.5478,
    y1: 18.1864,
    x2: 25.5478,
    y2: 7.18842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#647CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#38468F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_310_116",
    x1: 33.1876,
    y1: 22.5714,
    x2: 33.1876,
    y2: 11.5735,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#647CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#38468F"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMobile);
export default __webpack_public_path__ + "static/media/logo-mobile.54fcc7ce.svg";
export { ForwardRef as ReactComponent };